import React from 'react';

const Logos = () => {
  return (
    <div className='logos pr'>
      <div className='container'>
        <ul className='logos__list flex flex-center'>
          <li style={{ width: 'auto' }}>
            <a href='https://www.mic.gov.vn/'>
              <img width='80px' src='/assets/img/bdt.jpg' alt='' />
            </a>
          </li>
          <li style={{ width: 'auto' }}>
            <a href='https://mimedia.vn'>
              <img
                width='150px'
                src='/assets/img/mimedia.png'
                alt='mimedia.vn'
              />
            </a>
          </li>
          <li style={{ width: 'auto' }}>
            <a href=''>
              <img width='120px' src='/assets/img/vtv.jpg' alt='' />
            </a>
          </li>
          <li style={{ width: 'auto' }}>
            <a href=''>
              <img width='120px' src='/assets/img/vcci.jpg' alt='' />
            </a>
          </li>
          <li style={{ width: 'auto' }}>
            <a href=''>
              <img width='80px' src='/assets/img/bkh.jpg' alt='' />
            </a>
          </li>
          <li style={{ width: 'auto' }}>
            <a href=''>
              <img width='80px' src='/assets/img/vinasme.jpg' alt='' />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Logos;
